import { useState, useEffect } from "react";
import { getPlayers } from "../services/playerService";
import { useNavContext } from "../context/nav_context";

const usePlayers = (playerAid, playerBid) => {
  const { accessToken } = useNavContext();
  const [playerA, setPlayerA] = useState(null);
  const [playerB, setPlayerB] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!playerAid || !playerBid) return;

    let cancelled = false;

    const loadPlayers = async () => {
      try {
        setLoading(true);
        setError(false);
        const ids = [playerAid, playerBid].join(",");
        const players = await getPlayers(ids, accessToken);
        if (!cancelled && players) {
          const byId = new Map(players.map((p) => [p?.playerId, p]));
          setPlayerA(byId.get(playerAid) || null);
          setPlayerB(byId.get(playerBid) || null);
        }
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadPlayers();

    return () => {
      cancelled = true;
    };
  }, [playerAid, playerBid, accessToken]);

  return { playerA, playerB, loading, error };
};

export default usePlayers;
